// @flow
export default () => ({
    root: {},
    label: {},
    input: {},
    errorMessage: {},
});
